import { render, staticRenderFns } from "./WalletBannerTaxBack.vue?vue&type=template&id=1eb9177a&scoped=true&"
import script from "./WalletBannerTaxBack.vue?vue&type=script&lang=js&"
export * from "./WalletBannerTaxBack.vue?vue&type=script&lang=js&"
import style0 from "./WalletBannerTaxBack.vue?vue&type=style&index=0&id=1eb9177a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb9177a",
  null
  
)

export default component.exports